import axios from "axios";
import qs from "qs";

const fetchDataQrApi = async (page) => {
  const data = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${page}`);
  return data;
};

const postPage = async ({ pageUrl, pageData }) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}${pageUrl}`,
    qs.stringify(pageData)
  );
  return data;
};

const getPaymentProvider = async () => {
  const data = await axios.get(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/payment/GetPaymentMethod.php`
  );
  return data;
};

const getVoucher = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/promo/GetMyVoucher.php`,
    qs.stringify(pageData)
  );
  return data;
};

const bookingTable = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/table/BookingTable.php`,
    qs.stringify(pageData)
  );
  return data;
};

const cancelBookingTable = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/table/DelBookingTable.php`,
    qs.stringify(pageData)
  );
  return data;
};

const getFavorite = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/menu/GetFavoritMenu.php`,
    qs.stringify(pageData)
  );
  return data;
};

const getFavoriteMenu = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/menu/GetCustFavoritMenu.php`,
    qs.stringify(pageData)
  );
  return data;
};

const addFavorite = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/menu/FavoritMenu.php`,
    qs.stringify(pageData)
  );
  return data;
};

const delFavorite = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/menu/DelFavoritMenu.php`,
    qs.stringify(pageData)
  );
  return data;
};

const delFavoriteMenu = async (pageData) => {
  const data = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}api/v1/menu/DelCustFavoritMenu.php`,
    qs.stringify(pageData)
  );
  return data;
};

const pageService = {
  fetchDataQrApi,
  postPage,
  bookingTable,
  getVoucher,
  cancelBookingTable,
  getPaymentProvider,
  getFavorite,
  getFavoriteMenu,
  addFavorite,
  delFavorite,
  delFavoriteMenu,
};

export default pageService;
